var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-progress"},[_c('div',{staticClass:"common-progress__content",style:(_vm.style)},[_c('div',{staticClass:"common-progress__text"},[_vm._v(_vm._s(_vm.value)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }